import {
    Dashboard,
    LateEarlyJoin,
    ToDayDuty,
    AvailForDuty,
    NoDuty,
    DutyList,
    UserDutyDetails,
    ParadeEscape,
    ParadeEscapeUpdate,
    UserAbsentList,
    UserDutyList,
    CadreDutyPostUsers,
    UserAbsentDetails,
    DutyPostStatus,
    UserMonthlyDuty,
} from "../Components/index.js";

export default [
    {
        path: "/dashboard/duty",
        component: Dashboard,
        name: "report-duty-dashboard",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/daily-duty-post-status",
        component: () => import("@/App/Duty/Reports/Components/DailyDutyPostStatus.vue"),
        name: "report-daily-duty-post-status",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/duty-post/late-early-join",
        component: LateEarlyJoin,
        name: "report-duty-post-status",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/duty/today",
        component: ToDayDuty,
        name: "report-duty-today",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/avail-for-duty",
        component: AvailForDuty,
        name: "report-avail-for-duty-today",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/no-duty",
        component: NoDuty,
        name: "report-no-duty-today",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/parade-escape",
        component: ParadeEscape,
        name: "report-parade-escape",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/parade-escape/update",
        component: ParadeEscapeUpdate,
        name: "report-parade-escape.update",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/duty-list",
        component: DutyList,
        name: "report-duty-list-today",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/day-duty",
        component: () => import("../Components/DayDuty.vue"),
        name: "report-day-duty",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/night-duty",
        component: () => import("../Components/NightDuty.vue"),
        name: "report-night-duty",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/all-day-duty",
        component: () => import("../Components/AllDayDuty.vue"),
        name: "report-all-day-duty",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/user-duty-details/:user_id",
        component: UserDutyDetails,
        name: "report-user-duty-details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/my-duty-details",
        component: UserDutyDetails,
        name: "report-my-duty-details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/user-duty-list",
        component: UserDutyList,
        name: "report-user-duty-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/user-monthly-duty",
        component: UserMonthlyDuty,
        name: "report-user-monthly-duty",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/user-absent-list",
        component: UserAbsentList,
        name: "report-user-absent-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/cadre-duty-post-users",
        component: CadreDutyPostUsers,
        name: "report-cadre-duty-post-users",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/user-absent-details",
        component: UserAbsentDetails,
        name: "report-user-absent-details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/duty-post/status",
        component: DutyPostStatus,
        name: "duty-post-status",
        meta: {
            requiresAuth: true,
        },
    },
];
